<template>
  <span>
    <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
              <div class="flex items-center justify-between con-btns-user">
                <div class="flex items-center justify-start con-userx">
                  <vs-avatar color="primary" :text="supplierDetails.company_name"/>
                  <span class="font-semibold text-primary">{{ supplierDetails.company_name }}
                    <span v-if="supplierDetails.account_number">({{ supplierDetails.account_number}})</span>
                  </span>
                </div>
              </div>
            </div>
        </vx-card>
      </div>
    </div>
    <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General Details' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <courier-supplier-profile v-on:fetchSupplierData="fetchSupplierData($event)"/>
      </div>
    </vs-tab>
    <vs-tab v-if="$canAny(['view-goods-out-logistics','create-edit-goods-out-logistics'])" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Courier Shipments' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <courier-supplier-shipmen-list/>
      </div>
    </vs-tab>
  </vs-tabs>
  </span>
</template>

<script>
  import CourierSupplierProfile
    from "@/views/pages/supplier-manage/couriers/courier-supplier-tabs/CourierSupplierProfile";
  import CourierSupplierShipmenList
    from "@/views/pages/supplier-manage/couriers/courier-supplier-tabs/CourierSupplierShipmenList";
  import CourierSupplierServiceList
    from "@/views/pages/supplier-manage/couriers/courier-supplier-tabs/CourierSupplierServiceList";

  export default {
    components: {
      CourierSupplierProfile,
      CourierSupplierShipmenList,
      CourierSupplierServiceList
    },
    data () {
      return {
        active_step: this.$route.query.step ? this.$route.query.step : '0',
        supplierDetails: {}
      }
    },
    methods: {
      fetchSupplierData(data) {
        this.supplierDetails = data
      }
    },
    mounted() {
        // this.active_step = this.$route.query.step
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
